import type {
  CopyConversationRequest,
  CopyConversationResponse,
} from '@crowdex/agent-contracts/api';
import { apiFetch } from '@crowdex/host-kit/renderer/http';

/** A new conversation with the messages before `beforeMessageId`; the original stays as it is. */
export async function copyConversation(
  conversationId: string,
  beforeMessageId: string,
): Promise<CopyConversationResponse> {
  return await apiFetch<CopyConversationResponse>(
    `/api/conversations/${encodeURIComponent(conversationId)}/copy`,
    {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ beforeMessageId } satisfies CopyConversationRequest),
    },
  );
}
